import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'finance_cash_value',
  templateUrl: './finance_cash_value.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiscoveryFinanceCashValueComponent implements OnInit {
  @Input() data;
  @Output() dFinanceCashValueEmitter: EventEmitter<any> = new EventEmitter();

  ngOnInit(): void {}
  save() {
    this.dFinanceCashValueEmitter.emit({ status: 'forward', id: this.data.id });
  }

  back() {
    this.dFinanceCashValueEmitter.emit({ status: 'backward' });
  }
}
